export default __webpack_public_path__ + "static/avatar-kayi-common-8-cover-291b9e2b62df181f59f63f34a6d790d4.png";